<div class="question-container">
  <div class="title">{{ surveyTitle }}</div>
  @if (steps && steps.length > 0) {
    <div class="description">{{ description }}</div>
  } @else {
    <div class="description skeleton"></div>
  }
  <div class="description-action">{{ descriptionAction | translate }}</div>
</div>

<div #answerContainerElement class="answer-container">
  @if (currentStep) {
    @if (currentStep.type === stepTypes.QuestionWithOptionSetSingleSelection && answerOptions && answerOptions.length > 0) {
      <div class="answer-options" #answerOptionsElement [class.column]="useColumnView">
        @for (option of answerOptions; track option.labelKey; let i = $index) {
          <button
            #answerOptionElement
            class="answer-option"
            [class.selected]="selectedAnswer === option.labelKey"
            (click)="selectAnswerOption(option.labelKey, option.value)"
          >{{ steps[currentStepIndex].labels[option.labelKey] }}</button>
        }
      </div>
    } @if (currentStep.type === stepTypes.QuestionWithText) {
      <textarea
        class="textarea"
        placeholder="I..."
        [formControl]="message"
      ></textarea>

      @if (message.value !== null && message.value !== '') {
        <button class="save-button" (click)="saveTextAnswer()">
          {{ 'WebApp.v1.Shared.Buttons.Save' | translate }}
          <i class="fa fa-chevron-right fa-xl"></i>
        </button>
      } @else {
        <div class="skip" (click)="skipStep()">
          {{ 'WebApp.v1.Survey.SkipStep' | translate }}
          <i class="fa fa-chevron-right fa-xl"></i>
        </div>
      }
    }
  } @else {
    <div class="answer-options center" #answerOptionsElement [class.column]="useColumnView">
    @for (i of [1, 2, 3]; track i) {
        <div class="answer-option">
          <div class="skeleton"></div>
        </div>
      }
    </div>
  }
</div>